import { FC } from 'react';
import { cx } from '@/utils/cx';
import { StatusVariant } from './types/status-variant';

export type StatusBadgeProps = {
  text: string;
  variant: StatusVariant;
};

export const StatusBadge: FC<StatusBadgeProps> = ({ text, variant }) => (
  <div
    className={cx(
      `bg-${variant}Tint`,
      'flex flex-row items-center gap-1.5 rounded-full px-2.5 py-1',
    )}
  >
    <div className={cx(`bg-${variant}`, 'h-1.5 w-1.5 rounded-full')}></div>
    <div className={cx(`text-${variant}Shade`, 'text-xs font-medium')}>
      {text}
    </div>
  </div>
);

/**
 * Include tailwind classes
 * bg-successTint bg-alertTint bg-warningTint
 * bg-success bg-alert bg-warning
 * text-successShade text-alertShade text-warningShade
 */
